import { CloudSun, GraduationCap, MapPinned, type LucideIcon } from "lucide-react";
import type { ServiceType } from "../../data/types";
import { serviceNames } from "./shared";

export const serviceIcons: Record<ServiceType, LucideIcon> = {
  balloon: CloudSun,
  tour: MapPinned,
  school: GraduationCap,
};

/** Globo, Tours and Escolares are always told apart by the same color and icon. */
export function ServiceTag({ service }: { service: ServiceType }) {
  const Icon = serviceIcons[service];
  return (
    <span className={`service-tag service-tag--${service}`}>
      <Icon size={13} aria-hidden="true" />
      {serviceNames[service]}
    </span>
  );
}
